var _path, _path2, _path3, _text, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceItemHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2C4 1.44772 4.44772 1 5 1H12L16 5V18C16 18.5523 15.5523 19 15 19H5C4.44772 19 4 18.5523 4 18V2Z",
    fill: "url(#g1_ii_h)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1L16 5H13C12.4477 5 12 4.55228 12 4V1Z",
    fill: "#BDCEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5H10.5M8 13H12",
    stroke: "#BDCEEE",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 9,
    textAnchor: "middle",
    fill: "#BDCEEE",
    fontSize: 5,
    fontWeight: 700,
    fontFamily: "Arial"
  }, "$")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1_ii_h",
    x1: 10,
    y1: 1,
    x2: 10,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceItemHover);
export default __webpack_public_path__ + "static/media/invoice-item-hover.70f02d689472a4f098d149b5becddd90.svg";
export { ForwardRef as ReactComponent };